import { render, staticRenderFns } from "./CategoryGroupingSelect.vue?vue&type=template&id=893a28b0&scoped=true&"
import script from "./CategoryGroupingSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryGroupingSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGroupingSelect.vue?vue&type=style&index=0&id=893a28b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a28b0",
  null
  
)

export default component.exports